import { createReducer } from 'redux-act';
import actions from '../actions/policiesActions';

const initialState = {
    createPolicyCategoryPending: false,
    createPolicyCategoryRes: null,
    createPolicyCategoryError: null,

    getAllPolicyCategorysPending: false,
    getAllPolicyCategorysRes: null,
    getAllPolicyCategorysError: null,

    updatePolicyCategoryPending: false,
    updatePolicyCategoryRes: null,
    updatePolicyCategoryError: null,

    deletePolicyCategoryPending: false,
    deletePolicyCategoryRes: null,
    deletePolicyCategoryError: null,

    createPolicyPending: false,
    createPolicyRes: null,
    createPolicyError: null,

    getAllPolicyPending: false,
    getAllPolicyRes: null,
    getAllPolicyError: null,

    getPolicyByCategoryIdPending: false,
    getPolicyByCategoryIdRes: null,
    getPolicyByCategoryIdError: null,

    updatePolicyPending: false,
    updatePolicyRes: null,
    updatePolicyError: null,

    deletePolicyPending: false,
    deletePolicyRes: null,
    deletePolicyError: null,

    getPolicyConstantDataPending: false,
    getPolicyConstantDataRes: null,
    getPolicyConstantDataError: null,

    acceptPolicyByUserPending: false,
    acceptPolicyByUserRes: null,
    acceptPolicyByUserError: null,

    getPolicyCategoryListPending: false,
    getPolicyCategoryListRes: null,
    getPolicyCategoryListError: null,

    getPolicyListPending: false,
    getPolicyListRes: null,
    getPolicyListError: null,

    getClientTermsAndConditionsPending: false,
    getClientTermsAndConditionsRes: null,
    getClientTermsAndConditionsError: null,

    sendOtpVerificationPending: false,
    sendOtpVerificationRes: null,
    sendOtpVerificationError: null,

    verifyClientTermsOTPPending: false,
    verifyClientTermsOTPSuccess: null,
    verifyClientTermsOTPError: null,

    acceptAndRejectClientTermsPending: false,
    acceptAndRejectClientTermsRes: null,
    acceptAndRejectClientTermsError: null,
};
/* Add Policy Category Reducers */
const handleCreatePolicyCategoryRequest = state => {
    return {
        ...state,
        ...{
            createPolicyCategoryPending: true,
            createPolicyCategoryRes: null,
            createPolicyCategoryError: null,
        },
    };
};
const handleCreatePolicyCategorySuccess = (state, payload) => {
    return {
        ...state,
        ...{
            createPolicyCategoryPending: false,
            createPolicyCategoryRes: payload,
            createPolicyCategoryError: null,
        },
    };
};
const handleCreatePolicyCategoryError = (state, payload) => ({
    ...state,
    ...{
        createPolicyCategoryPending: false,
        createPolicyCategoryRes: null,
        createPolicyCategoryError: payload,
    },
});


/* Get All Policy Categorys Reducers */
const handleGetAllPolicyCategorysRequest = state1 => {
    return {
        ...state1,
        ...{
            getAllPolicyCategorysPending: true,
            getAllPolicyCategorysRes: null,
            getAllPolicyCategorysError: null,
        },
    };
};
const handleGetAllPolicyCategorysSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAllPolicyCategorysPending: false,
            getAllPolicyCategorysRes: payload,
            getAllPolicyCategorysError: null,
        },
    };
};
const handleGetAllPolicyCategorysError = (state1, payload) => ({
    ...state1,
    ...{
        getAllPolicyCategorysPending: false,
        getAllPolicyCategorysRes: null,
        getAllPolicyCategorysError: payload,
    },
});

/* Update Policy Category List Reducers */
const handleUpdatePolicyCategoryRequest = state1 => {
    return {
        ...state1,
        ...{
            updatePolicyCategoryPending: true,
            updatePolicyCategoryRes: null,
            updatePolicyCategoryError: null,
        },
    };
};
const handleUpdatePolicyCategorySuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            updatePolicyCategoryPending: false,
            updatePolicyCategoryRes: payload,
            updatePolicyCategoryError: null,
        },
    };
};
const handleUpdatePolicyCategoryError = (state1, payload) => ({
    ...state1,
    ...{
        updatePolicyCategoryPending: false,
        updatePolicyCategoryRes: null,
        updatePolicyCategoryError: payload,
    },
});

/* Delete Policy Category Reducers */
const handleDeletePolicyCategoryRequest = state1 => {
    return {
        ...state1,
        ...{
            deletePolicyCategoryPending: true,
            deletePolicyCategoryRes: null,
            deletePolicyCategoryError: null,
        },
    };
};
const handleDeletePolicyCategorySuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            deletePolicyCategoryPending: false,
            deletePolicyCategoryRes: payload,
            deletePolicyCategoryError: null,
        },
    };
};
const handleDeletePolicyCategoryError = (state1, payload) => ({
    ...state1,
    ...{
        deletePolicyCategoryPending: false,
        deletePolicyCategoryRes: null,
        deletePolicyCategoryError: payload,
    },
});

/* Create Policy Reducer */
const handleCreatePolicyRequest = state1 => {
    return {
        ...state1,
        ...{
            createPolicyPending: true,
            createPolicyRes: null,
            createPolicyError: null,
        },
    };
};
const handleCreatePolicySuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            createPolicyPending: false,
            createPolicyRes: payload,
            createPolicyError: null,
        },
    };
};
const handleCreatePolicyError = (state1, payload) => ({
    ...state1,
    ...{
        createPolicyPending: false,
        createPolicyRes: null,
        createPolicyError: payload,
    },
});

/* Get All Policy Reducer */
const handleGetAllPolicyRequest = state1 => {
    return {
        ...state1,
        ...{
            getAllPolicyPending: true,
            getAllPolicyRes: null,
            getAllPolicyError: null,
        },
    };
};
const handleGetAllPolicySuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAllPolicyPending: false,
            getAllPolicyRes: payload,
            getAllPolicyError: null,
        },
    };
};
const handleGetAllPolicyError = (state1, payload) => ({
    ...state1,
    ...{
        getAllPolicyPending: false,
        getAllPolicyRes: null,
        getAllPolicyError: payload,
    },
});

/* Get Policy By Category Id Reducer */
const handleGetPolicyByCategoryIdRequest = state1 => {
    return {
        ...state1,
        ...{
            getPolicyByCategoryIdPending: true,
            getPolicyByCategoryIdRes: null,
            getPolicyByCategoryIdError: null,
        },
    };
};
const handleGetPolicyByCategoryIdSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getPolicyByCategoryIdPending: false,
            getPolicyByCategoryIdRes: payload,
            getPolicyByCategoryIdError: null,
        },
    };
};
const handleGetPolicyByCategoryIdError = (state1, payload) => ({
    ...state1,
    ...{
        getPolicyByCategoryIdPending: false,
        getPolicyByCategoryIdRes: null,
        getPolicyByCategoryIdError: payload,
    },
});

/* Update Policy Reducer */
const handleUpdatePolicyRequest = state1 => {
    return {
        ...state1,
        ...{
            updatePolicyPending: true,
            updatePolicyRes: null,
            updatePolicyError: null,
        },
    };
};
const handleUpdatePolicySuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            updatePolicyPending: false,
            updatePolicyRes: payload,
            updatePolicyError: null,
        },
    };
};
const handleUpdatePolicyError = (state1, payload) => ({
    ...state1,
    ...{
        updatePolicyPending: false,
        updatePolicyRes: null,
        updatePolicyError: payload,
    },
});

/* Delete Policy Reducer */
const handleDeletePolicyRequest = state1 => {
    return {
        ...state1,
        ...{
            deletePolicyPending: true,
            deletePolicyRes: null,
            deletePolicyError: null,
        },
    };
};
const handleDeletePolicySuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            deletePolicyPending: false,
            deletePolicyRes: payload,
            deletePolicyError: null,
        },
    };
};
const handleDeletePolicyError = (state1, payload) => ({
    ...state1,
    ...{
        deletePolicyPending: false,
        deletePolicyRes: null,
        deletePolicyError: payload,
    },
});


/* Accept Policy By User Reducer */
const handleAcceptPolicyByUserRequest = state1 => {
    return {
        ...state1,
        ...{
            acceptPolicyByUserPending: true,
            acceptPolicyByUserRes: null,
            acceptPolicyByUserError: null,
        },
    };
};
const handleAcceptPolicyByUserSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            acceptPolicyByUserPending: false,
            acceptPolicyByUserRes: payload,
            acceptPolicyByUserError: null,
        },
    };
};
const handleAcceptPolicyByUserError = (state1, payload) => ({
    ...state1,
    ...{
        acceptPolicyByUserPending: false,
        acceptPolicyByUserRes: null,
        acceptPolicyByUserError: payload,
    },
});

/* Get Policy Category List Reducer */
const handleGetPolicyCategoryListRequest = state1 => {
    return {
        ...state1,
        ...{
            getPolicyCategoryListPending: true,
            getPolicyCategoryListRes: null,
            getPolicyCategoryListError: null,
        },
    };
};
const handleGetPolicyCategoryListSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getPolicyCategoryListPending: false,
            getPolicyCategoryListRes: payload,
            getPolicyCategoryListError: null,
        },
    };
};
const handleGetPolicyCategoryListError = (state1, payload) => ({
    ...state1,
    ...{
        getPolicyCategoryListPending: false,
        getPolicyCategoryListRes: null,
        getPolicyCategoryListError: payload,
    },
});

/* Get Policy List Reducer */
const handleGetPolicyListRequest = state1 => {
    return {
        ...state1,
        ...{
            getPolicyListPending: true,
            getPolicyListRes: null,
            getPolicyListError: null,
        },
    };
};
const handleGetPolicyListSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getPolicyListPending: false,
            getPolicyListRes: payload,
            getPolicyListError: null,
        },
    };
};
const handleGetPolicyListError = (state1, payload) => ({
    ...state1,
    ...{
        getPolicyListPending: false,
        getPolicyListRes: null,
        getPolicyListError: payload,
    },
});

/* Get Policy List Reducer */
const handleGetClientTermsAndConditionsRequest = state1 => {
    return {
        ...state1,
        ...{
            getClientTermsAndConditionsPending: true,
            getClientTermsAndConditionsRes: null,
            getClientTermsAndConditionsError: null,
        },
    };
};
const handleGetClientTermsAndConditionsSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getClientTermsAndConditionsPending: false,
            getClientTermsAndConditionsRes: payload,
            getClientTermsAndConditionsError: null,
        },
    };
};
const handleGetClientTermsAndConditionsError = (state1, payload) => ({
    ...state1,
    ...{
        getClientTermsAndConditionsPending: false,
        getClientTermsAndConditionsRes: null,
        getClientTermsAndConditionsError: payload,
    },
});


/* send Otp Verification Reducer */
const handleSendOtpVerificationRequest = state1 => {
    return {
        ...state1,
        ...{
            sendOtpVerificationPending: true,
            sendOtpVerificationRes: null,
            sendOtpVerificationError: null,
        },
    };
};
const handleSendOtpVerificationSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            sendOtpVerificationPending: false,
            sendOtpVerificationRes: payload,
            sendOtpVerificationError: null,
        },
    };
};
const handleSendOtpVerificationError = (state1, payload) => ({
    ...state1,
    ...{
        sendOtpVerificationPending: false,
        sendOtpVerificationRes: null,
        sendOtpVerificationError: payload,
    },
});


/* send Otp Verification Reducer */
const handleVerifyClientTermsOTPRequest = state1 => {
    return {
        ...state1,
        ...{
            verifyClientTermsOTPPending: true,
            verifyClientTermsOTPRes: null,
            verifyClientTermsOTPError: null,
        },
    };
};
const handleVerifyClientTermsOTPSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            verifyClientTermsOTPPending: false,
            verifyClientTermsOTPRes: payload,
            verifyClientTermsOTPError: null,
        },
    };
};
const handleVerifyClientTermsOTPError = (state1, payload) => ({
    ...state1,
    ...{
        verifyClientTermsOTPPending: false,
        verifyClientTermsOTPRes: null,
        verifyClientTermsOTPError: payload,
    },
});


/* Accept And Reject ClientTerms Reducer */
const handleAcceptAndRejectClientTermsRequest = state1 => {
    return {
        ...state1,
        ...{
            acceptAndRejectClientTermsPending: true,
            acceptAndRejectClientTermsRes: null,
            acceptAndRejectClientTermsError: null,
        },
    };
};
const handleAcceptAndRejectClientTermsSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            acceptAndRejectClientTermsPending: false,
            acceptAndRejectClientTermsRes: payload,
            acceptAndRejectClientTermsError: null,
        },
    };
};
const handleAcceptAndRejectClientTermsError = (state1, payload) => ({
    ...state1,
    ...{
        acceptAndRejectClientTermsPending: false,
        acceptAndRejectClientTermsRes: null,
        acceptAndRejectClientTermsError: payload,
    },
});

/* Clear Policy Store */
const handleClearPolicyStore = (state, payload) => {
    switch (payload) {
        case 'HANDLE_CLEAR_CREATE_POLICY_CATEGORY_STORE':
            return {
                ...state,
                ...{
                    createPolicyCategoryPending: false,
                    createPolicyCategoryRes: null,
                    createPolicyCategoryError: null,
                },
            };
        case 'HANDLE_CLEAR_UPDATE_POLICY_CATEGORY_STORE':
            return {
                ...state,
                ...{
                    updatePolicyCategoryPending: false,
                    updatePolicyCategoryRes: null,
                    updatePolicyCategoryError: null,

                },
            };
        case 'HANDLE_CLEAR_DELETE_POLICY_CATEGORY_STORE':
            return {
                ...state,
                ...{
                    deletePolicyCategoryPending: false,
                    deletePolicyCategoryRes: null,
                    deletePolicyCategoryError: null,
                },
            };

        case 'HANDLE_CLEAR_CREATE_POLICY_STORE':
            return {
                ...state,
                ...{
                    createPolicyPending: false,
                    createPolicyRes: null,
                    createPolicyError: null,
                },
            };
        case 'HANDLE_CLEAR_UPDATE_POLICY_STORE':
            return {
                ...state,
                ...{
                    updatePolicyPending: false,
                    updatePolicyRes: null,
                    updatePolicyError: null,
                },
            };
        case 'HANDLE_CLEAR_DELETE_POLICY_STORE':
            return {
                ...state,
                ...{
                    deletePolicyPending: false,
                    deletePolicyRes: null,
                    deletePolicyError: null,
                },
            };
        case 'HANDLE_CLEAR_ACCEPT_POLICY_BY_USER':
            return {
                ...state,
                ...{
                    acceptPolicyByUserPending: false,
                    acceptPolicyByUserRes: null,
                    acceptPolicyByUserError: null,
                },
            };

        case 'HANDLE_CLEAR_VERIFY_CLIENT_TERMS_OTP':
            return {
                ...state,
                ...{
                    verifyClientTermsOTPPending: false,
                    verifyClientTermsOTPRes: null,
                    verifyClientTermsOTPError: null,
                },
            };
        case 'HANDLE_CLEAR_VERIFY_CLIENT_TERMS_OTP':
            return {
                ...state,
                ...{
                    acceptAndRejectClientTermsPending: false,
                    acceptAndRejectClientTermsRes: null,
                    acceptAndRejectClientTermsError: null,
                },
            };
        case 'HANDLE_CLEAR_ACCEPT_AND_REJECT_CLIENT_TERMS':
            return {
                ...state,
                ...{
                    acceptAndRejectClientTermsPending: false,
                    acceptAndRejectClientTermsRes: null,
                    acceptAndRejectClientTermsError: null,
                },
            };

        case 'HANDLE_CLEAR_SEND_OTP_VERIFICATION':
            return {
                ...state,
                ...{
                    sendOtpVerificationPending: false,
                    sendOtpVerificationRes: null,
                    sendOtpVerificationError: null,
                },
            };
        default:
            return state;
    }
};



export default createReducer(
    {
        [actions.createPolicyCategoryRequest]: handleCreatePolicyCategoryRequest,
        [actions.createPolicyCategorySuccess]: handleCreatePolicyCategorySuccess,
        [actions.createPolicyCategoryError]: handleCreatePolicyCategoryError,

        [actions.getAllPolicyCategorysRequest]: handleGetAllPolicyCategorysRequest,
        [actions.getAllPolicyCategorysSuccess]: handleGetAllPolicyCategorysSuccess,
        [actions.getAllPolicyCategorysError]: handleGetAllPolicyCategorysError,

        [actions.updatePolicyCategoryRequest]: handleUpdatePolicyCategoryRequest,
        [actions.updatePolicyCategorySuccess]: handleUpdatePolicyCategorySuccess,
        [actions.updatePolicyCategoryError]: handleUpdatePolicyCategoryError,

        [actions.deletePolicyCategoryRequest]: handleDeletePolicyCategoryRequest,
        [actions.deletePolicyCategorySuccess]: handleDeletePolicyCategorySuccess,
        [actions.deletePolicyCategoryError]: handleDeletePolicyCategoryError,

        [actions.createPolicyRequest]: handleCreatePolicyRequest,
        [actions.createPolicySuccess]: handleCreatePolicySuccess,
        [actions.createPolicyError]: handleCreatePolicyError,

        [actions.getAllPolicyRequest]: handleGetAllPolicyRequest,
        [actions.getAllPolicySuccess]: handleGetAllPolicySuccess,
        [actions.getAllPolicyError]: handleGetAllPolicyError,

        [actions.getPolicyByCategoryIdRequest]: handleGetPolicyByCategoryIdRequest,
        [actions.getPolicyByCategoryIdSuccess]: handleGetPolicyByCategoryIdSuccess,
        [actions.getPolicyByCategoryIdError]: handleGetPolicyByCategoryIdError,

        [actions.updatePolicyRequest]: handleUpdatePolicyRequest,
        [actions.updatePolicySuccess]: handleUpdatePolicySuccess,
        [actions.updatePolicyError]: handleUpdatePolicyError,

        [actions.deletePolicyRequest]: handleDeletePolicyRequest,
        [actions.deletePolicySuccess]: handleDeletePolicySuccess,
        [actions.deletePolicyError]: handleDeletePolicyError,

        [actions.acceptPolicyByUserRequest]: handleAcceptPolicyByUserRequest,
        [actions.acceptPolicyByUserSuccess]: handleAcceptPolicyByUserSuccess,
        [actions.acceptPolicyByUserError]: handleAcceptPolicyByUserError,

        [actions.getPolicyCategoryListRequest]: handleGetPolicyCategoryListRequest,
        [actions.getPolicyCategoryListSuccess]: handleGetPolicyCategoryListSuccess,
        [actions.getPolicyCategoryListError]: handleGetPolicyCategoryListError,

        [actions.getPolicyListRequest]: handleGetPolicyListRequest,
        [actions.getPolicyListSuccess]: handleGetPolicyListSuccess,
        [actions.getPolicyListError]: handleGetPolicyListError,

        [actions.getClientTermsAndConditionsRequest]: handleGetClientTermsAndConditionsRequest,
        [actions.getClientTermsAndConditionsSuccess]: handleGetClientTermsAndConditionsSuccess,
        [actions.getClientTermsAndConditionsError]: handleGetClientTermsAndConditionsError,

        [actions.sendOtpVerificationRequest]: handleSendOtpVerificationRequest,
        [actions.sendOtpVerificationSuccess]: handleSendOtpVerificationSuccess,
        [actions.sendOtpVerificationError]: handleSendOtpVerificationError,

        [actions.verifyClientTermsOTPRequest]: handleVerifyClientTermsOTPRequest,
        [actions.verifyClientTermsOTPSuccess]: handleVerifyClientTermsOTPSuccess,
        [actions.verifyClientTermsOTPError]: handleVerifyClientTermsOTPError,

        [actions.acceptAndRejectClientTermsRequest]: handleAcceptAndRejectClientTermsRequest,
        [actions.acceptAndRejectClientTermsSuccess]: handleAcceptAndRejectClientTermsSuccess,
        [actions.acceptAndRejectClientTermsError]: handleAcceptAndRejectClientTermsError,

        [actions.handleClearPolicyStore]: handleClearPolicyStore,
    },
    initialState,
);